import React from "react";

import { useShopQuery } from "@hooks/use-shop-query.js";
import { gql } from "graphql-request";

const queryProducts = gql`
query ProductAndCollection($country:CountryCode!, $productHandle:String!) @inContext(country: $country){
	product(handle:$productHandle){
		title,
		cartNotes: metafields(identifiers: [
			  {namespace: "cart-notes", key: "page"}
				{namespace: "cart-notes", key: "rules"}
				{namespace: "cart-notes", key: "priority"}
			]) {
			  key
			  value
		}
    includedItemsTitle: metafield(namespace: "accentuate", key: "included_item_title") {
      value
    }
    variants(first:100){
      edges{
        node{
          title,
          id,
					sku,
					available: availableForSale,
					options: selectedOptions{
						name,
						value
					}
					price {
						amount
					}
          compareAtPrice {
            amount
          }
          compatibilityKeys: metafield(namespace: "compatibility", key: "keys") {
            value
          },
          compatibilityCollection: metafield(namespace: "compatibility", key: "collection") {
            value
          }
          partnerVariant: metafield(namespace: "compatibility", key: "partner_variant") {
            value
          }
          includedItems: metafield(namespace: "included", key: "product_variants") {
            value,
            references(first: 8) {
              edges {
                node {
                  ...on ProductVariant {
                    title
                    id
					          sku
                    image{
		                  url
		                  altText
	                  }
                    price {
						          amount
					          }
                  }
                }
              }
            }
          }
        }
      }
    }
	}
}`

export const ProductCustomizerVariantContext = React.createContext({
  loading: true
});

export const ProductCustomizerVariantProvider = ({children, productHandle, variantId}) => {

  const variables = { productHandle, country: Shopify.country }
  const {data, loading:productLoading, error} = useShopQuery(queryProducts, variables);

  const variant = data?.product?.variants.find(({id})=>{
    return id.indexOf(variantId) > -1;
  });

  if(variant){variant.includedItemsTitle = data?.product?.includedItemsTitle};

  return <ProductCustomizerVariantContext.Provider value={{ loading:productLoading, variant, product: data?.product }}>
    {children}
    </ProductCustomizerVariantContext.Provider>;
}
